import type { ShareInfo } from "../net/api";

export function parseShares(text: string): ShareInfo[] {
  const out: ShareInfo[] = [];
  const seen = new Set<string>();
  for (const raw of text.split("\n")) {
    const line = raw.trim();
    if (!line || seen.has(line)) continue;
    seen.add(line);
    out.push(line.startsWith("plot:") ? { plot: line.slice(5).trim() } : { account: line });
  }
  return out;
}

export function formatShares(shares: ShareInfo[]): string {
  return shares.map((s) => (s.plot ? `plot:${s.plot}` : s.account ?? "")).join("\n");
}
